import { AxiosInstance } from 'axios'

import { JsonUpdate, Profile } from '../../../domain'
import { withGenericErrorHandling } from '../errors'

export interface ProfileClient {
  getSecondaryProfiles: () => Promise<Profile[]>
  getProfile: (profileCode: string) => Promise<Profile>
  createProfile: () => Promise<Profile>
  updateProfile: (profileCode: string, updates: JsonUpdate[]) => Promise<Profile>
}

export const createProfileClient = (
  getInstance: () => Promise<AxiosInstance>,
): ProfileClient => ({
  getSecondaryProfiles: () =>
    withGenericErrorHandling(async () => {
      const instance = await getInstance()
      const response = await instance.get<Profile[]>('/profiles', {
        params: { policyholder: false },
      })
      return response.data
    }),

  getProfile: (profileCode) =>
    withGenericErrorHandling(async () => {
      const instance = await getInstance()
      const response = await instance.get<Profile>(`/profiles/${profileCode}`)
      return response.data
    }),

  createProfile: () =>
    withGenericErrorHandling(async () => {
      const instance = await getInstance()
      const response = await instance.post<Profile>('/profiles')
      return response.data
    }),

  updateProfile: (profileCode, updates) =>
    withGenericErrorHandling(async () => {
      const instance = await getInstance()
      const response = await instance.patch<Profile>(`/profiles/${profileCode}`, {
        updates,
      })
      return response.data
    }),
})
